<template>
    <el-tooltip :content="showContent" :disabled="!showContent">
        <Cascader popper-class="cascaderClick" ref="cascader" v-model="val" @mouseover.native.once="handleChange" @change="(e)=>{$emit('change',e);handleChange()}" v-bind="$attrs"/>
    </el-tooltip>
</template>

<script>
import { Cascader } from 'element-ui';
export default {
    name:'el-tip-cascader',
    props: {
        // v-model绑定值
        value: {
            default: null
        }
    },
    components:{
        Cascader
    },
    data() {
        return {
            val: this.value,
            showContent:null
        }
    },
    watch: {
        val(data) {
            this.$emit('input', data)
            this.$emit('change', data)
        }
    },
    methods: {
        handleChange() {
            this.showContent = null
            this.handleContent(this.val)
        },
        handleContent(value) {
            // 获得当前组件
            const cascader = this.$refs.cascader
            let node = null
            // 根据变化后的值获得节点信息
            if(!Array.isArray(value)){
                // 如果项目中绑定的value值经过处理不是数组而是选中的叶子节点的value，则可以直接获取节点
                node = cascader.panel.getNodeByValue(value)
            }else{
                // 否则需要先获得叶子节点值再获得节点。由于cascader默认保存的value数据是按从父到子的顺序保存的，因此数组中的最后一个值就是叶子节点值
                const leaf = value[value.length - 1]
                node = cascader.panel.getNodeByValue(leaf)
            }
            // 获得全路径内容
            this.showContent = node&&node.getText(cascader.showAllLevels, cascader.separator)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/common/cascader.vue